<template>
  <div class="details">
    <!-- Display species cards when no electorate has been selected -->
    <div class="cards" v-if="speciesData.name === ''">
      <div class="title">
        <h2>My Backyard</h2>
        <div class="description">
          Learn about the wildlife that call your backyard home
        </div>
      </div>

      <div class="species-card" v-for="(card, index) of cards" :key="index">
        <Card
          :isReversed="index % 2 === 1"
          :pictureUrl="card.pictureUrl"
          :title="card.title"
          :description="card.description"
        ></Card>
      </div>

      <div class="back-top">
        <div class="clickable" @click="scrollTop">
          <i class="fa fa-angle-up"></i>
          <p>Back to top</p>
        </div>
      </div>
    </div>

    <!-- Display electorate's hero species when one has been selected -->
    <div class="hero-species" v-if="speciesData.name !== ''">
      <HeroSpecies></HeroSpecies>
      <ActionForm
        :datalayerName="datalayerName"
        :programName="programName"
        :messageId="messageId"
      ></ActionForm>
    </div>

    <!-- Make a difference and endangered species component -->
    <div class="other" v-if="speciesData.name !== ''">
      <Other></Other>
    </div>

    <div class="partners">
      <Partners></Partners>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Card from "./Card.vue";
import HeroSpecies from "./HeroSpecies.vue";
import ActionForm from "./ActionForm.vue";
import Other from "./Other.vue";
import Partners from "./Partners.vue";

export default {
  name: "ThreatenedSpecies",
  components: {
    Card,
    HeroSpecies,
    ActionForm,
    Other,
    Partners,
  },
  props: {
    datalayerName: {
      type: String,
      required: true,
    },

    // MARKETO
    programName: {
      type: String,
      required: true,
    },

    messageId: {
      type: String,
    },

    cards: {
      type: Array,
      default: () => [
        {
          pictureUrl: "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/my-backyard-landing-image-1.jpg",
          title: "Our wildlife is uniquely Australian",
          description:
            "Australia is home to an incredible array of threatened wildlife found nowhere else in the world",
        },
        {
          pictureUrl: "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/my-backyard-landing-image-2.jpg",
          title: "1,800 animals and plants are at risk of extinction",
          description:
            "Sadly, iconic wildlife, including east coast koalas and the greater glider, are at risk of disappearing forever",
        },
        {
          pictureUrl: "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/my-backyard-landing-image-3.jpg",
          title: "Protecting our wildlife and wild places",
          description:
            "To bring our wildlife back from the brink of extinction, we need stronger national nature laws that protect them and the places they call home. Add your voice today and make an impact",
        },
      ],
    },
  },
  computed: {
    ...mapGetters(["speciesData"]),
  },
  methods: {
    scrollTop() {
      document.getElementById("ra-header").scrollIntoView({
        behavior: "smooth",
      });
      this.$store.dispatch("logSimpleEvent", {
        eventName: "Back to Top Link",
        eventProperties: { Click: true },
      });
    },
  },
};
</script>

<style scoped>
.details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 64px;
}

.title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

h2 {
  margin: 0;
}

.cards {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.back-top {
  display: flex;
  justify-content: center;
  align-items: center;
}

.clickable {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: min-content;
}

.back-top i {
  color: #a7a9ac;
}

.back-top p {
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  text-transform: uppercase;
  width: max-content;
  color: #a7a9ac;
}

.hero-species {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64px;
  width: 100%;
  max-width: 1250px;
}

.partners {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 24px;
  background-color: #fbfbfa;
  width: 100%;
}

.partners .partners-pictures {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
}

.partners .partners-pictures .partner {
  width: 250px;
  height: 80px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.cards,
.other,
.partners {
  padding: 0 64px;
}

@media screen and (max-width: 680px) {
  .partners-pictures {
    flex-direction: column;
  }

  .cards {
    padding: 0 24px;
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// ThreatenedSpecies.vue?3aa9a212